import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, X } from 'lucide-react';
import partnerApi, { getPartnerToken } from '../lib/partnerApi';

export const PartnerWelcomeBanner = () => {
  const [partner, setPartner] = useState(null);

  useEffect(() => {
    if (!getPartnerToken()) return;
    partnerApi.get('/partners/me').then((r) => setPartner(r.data)).catch(() => {});
  }, []);

  if (!partner || partner.welcome_dismissed) return null;

  const dismiss = () => {
    setPartner({ ...partner, welcome_dismissed: true });
    partnerApi.post('/partners/welcome-dismissed').catch(() => {});
  };

  return (
    <div className="bg-mustard text-charcoal relative" data-testid="partner-welcome-banner">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 py-4 flex items-start md:items-center gap-3 flex-col md:flex-row">
        <div className="flex-1 text-sm leading-relaxed">
          <span className="font-bold">Welcome{partner.contact_name ? `, ${partner.contact_name.split(' ')[0]}` : ''}! New to the partner portal?</span>{' '}
          Our getting-started guide walks you through editing your listing, submitting events, your membership
          and everything else your account can do — and it&apos;s always there when you need it.
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link to="/partners/guide" data-testid="welcome-banner-guide-link"
            className="inline-flex items-center gap-1.5 bg-charcoal text-cream text-sm font-semibold rounded-full px-4 py-2 hover:bg-charcoal/85 transition-colors">
            <BookOpen size={14} /> Read the guide
          </Link>
          <button onClick={dismiss} data-testid="welcome-banner-dismiss" aria-label="Dismiss welcome message"
            className="p-2 rounded-full hover:bg-charcoal/10 transition-colors">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PartnerWelcomeBanner;
